import { snakeCase } from 'lodash';

export const getActionType = actionName =>
  `COMMON_APP/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});

export const updateByProp = (arr, uniqId, prop, update) => {
  const i = arr.findIndex(el => el[prop] === uniqId);

  if (i === -1) return arr;

  return [...arr.slice(0, i), { ...arr[i], ...update }, ...arr.slice(i + 1)];
};
